
<!-- Inspiration: Code de Jean-François Lavigne (Sidlee) -->
<!-- https://codepen.io/jflavigne/pen/MWpKpPG -->

<div :class="jel_getClassObject(content)" class="w-100 ios-margin">
  <b-aspect :aspect="formatCarte" class="w-100">
    <div class="card" :class="`format-${content.formatCarte}`">
      <div class="card-body d-flex">
        <slot></slot>
      </div>
    </div>
  </b-aspect>
</div>
